import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var VenusDouble = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M192 288c61.9 0 112-50.1 112-112S253.9 64 192 64 80 114.1 80 176s50.1 112 112 112zm176-112c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32v-34.9C78.1 334.1 16 262.3 16 176 16 78.8 94.8 0 192 0s176 78.8 176 176zm-24 142c14.6-15.6 26.8-33.4 36-53 18.8 14.4 42.4 23 68 23 61.9 0 112-50.1 112-112S509.9 64 448 64c-25.6 0-49.1 8.6-68 23-9.3-19.5-21.5-37.4-36-53 29.1-21.4 65.1-34 104-34 97.2 0 176 78.8 176 176 0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32h-32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32h-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32v-34.9c-26.6-4.9-51.1-15.7-72-31.1z"
  }));
});
VenusDouble.displayName = 'VenusDouble';
export var VenusDoubleDimensions = {
  height: 512,
  width: 640
};